export const boardType = {
    ci: {
        name: 'Commerce and Industry'
    }
};